import React from "react";
import PropTypes from "prop-types";

class BasicLabel extends React.Component {
    render() {
        return (
            <div>
                {this.props.text}
            </div>
        );
    }
}

BasicLabel.propTypes = {
    text: PropTypes.string
};

export default BasicLabel;



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/BasicLabel.jsx